import { createSlice } from "@reduxjs/toolkit";
import { apiCallBegan } from "../api";
import BASE_URL from "../../config/host";

export const jobSlice = createSlice({
  name: "jobs",
  loading: false,
  initialState: {
    joblist: [],
  },
  reducers: {
    listRequested: (state, action) => {
      state.loading = true;
    },
    listRequestFailed: (state, action) => {
      state.loading = false;
      state.joblist = "";
      //console.log(action.payload);
    },
    listReceived: (state, action) => {
      state.loading = false;
      state.joblist = action.payload.data ? action.payload.data : [];
    },
  },
});

export const { listReceived, listRequested, listRequestFailed } =
  jobSlice.actions;
//console.log(body);
export const fetchJobs = (body) =>
  apiCallBegan({
    url: "/job/list",
    method: "post",
    data: body,
    baseUrl: BASE_URL,
    onSuccess: listReceived.type,
    onStart: listRequested.type,
    onError: listRequestFailed.type,
  });
